import { Environments } from '@/config';
import { HELIX_MUSC_PRODUCTION } from './helix-musc.production';
import { HELIX_MUSC_STAGING } from './helix-musc.staging';

export const HELIX_MUSC = import.meta.env.MODE === Environments.PROD ? HELIX_MUSC_PRODUCTION : HELIX_MUSC_STAGING;
